import { getServiceImage } from "../module/api_init";
import mark_icon from "../asset/mark.svg";

export default function ServiceAll({ props }) {
  const { service } = props.state;
  return (
    <div className="service_body">
      <div className="service_title">{service.title}</div>

      {service.servicetype.map((item, k) => (
        <div key={k} className="service_each_area">
          <img
            className="service_each_img"
            src={getServiceImage(item.image)}
            alt="Kalyanimotors Leading Maruti Suzuki Dealership"
          />
          <div className="service_each">
            <div className="service_each_title_bar">
              <div className="service_each_title">{item.title}</div>
              <div className="service_each_time">
                <div className="service_each_time_icon" />
                {item.duration}
              </div>
            </div>
            <div className="service_each_subtitle">
              • {item.service_period}&nbsp;&nbsp;&nbsp; • {item.warranty}
            </div>
            <div className="service_each_datas">
              {item.servicelist.map((it, k) => (
                <div key={k} className="service_each_data">
                  <img style={{ marginRight: 7 }} alt="Kalyanimotors Leading Maruti Suzuki Dealership" src={mark_icon} />
                  {it.service}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", alignItems: "end" }}>
              <button
                onClick={() =>
                  props.setState({ enquiryPopup: { car: item.title, type: 8,item:item } })
                }
                className="service_select"
              >
                Book Your Service
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
